export default "__VITE_ASSET__S7p371pr__"